var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1875 7.55C23.7676 5.42215 22.622 3.50607 20.9463 2.12906C19.2707 0.752041 17.1689 -0.000490303 15 2.39671e-07C11.3875 2.39671e-07 8.25 2.05 6.6875 5.05C4.85029 5.24854 3.15126 6.11901 1.91686 7.49415C0.682464 8.86929 -0.000214627 10.6521 5.06159e-08 12.5C5.06159e-08 16.6375 3.3625 20 7.5 20H23.75C27.2 20 30 17.2 30 13.75C30 10.45 27.4375 7.775 24.1875 7.55ZM13.3875 15.3625C13.2719 15.4784 13.1345 15.5703 12.9833 15.633C12.8321 15.6958 12.67 15.7281 12.5063 15.7281C12.3425 15.7281 12.1804 15.6958 12.0292 15.633C11.878 15.5703 11.7406 15.4784 11.625 15.3625L9 12.75C8.88427 12.6343 8.79247 12.4969 8.72984 12.3457C8.66721 12.1945 8.63497 12.0324 8.63497 11.8687C8.63497 11.5382 8.76628 11.2212 9 10.9875C9.23372 10.7538 9.55072 10.6225 9.88125 10.6225C10.2118 10.6225 10.5288 10.7538 10.7625 10.9875L12.5 12.725L18.1 7.125C18.3337 6.89128 18.6507 6.75997 18.9813 6.75997C19.3118 6.75997 19.6288 6.89128 19.8625 7.125C20.0962 7.35872 20.2275 7.67572 20.2275 8.00625C20.2275 8.33678 20.0962 8.65378 19.8625 8.8875L13.3875 15.3625Z",
    fill: "#FFCA09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/DoneIcon.e08f721dd74303c43364175f895ea55f.svg";
export { ForwardRef as ReactComponent };